import React from 'react';
import BarChart from './BarChart';
import { Card, CardContent, Typography, Box, CircularProgress, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CardGraph = ({ title, chartData, height = 350, isLoading, showValues = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Adjust height for mobile if default height is used
    const responsiveHeight = isMobile && height === 350 ? 280 : height;

    return (
        <Card
            className="glass-card"
            elevation={0}
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.1) !important',
                },
            }}
        >
            <Box
                sx={{
                    p: isMobile ? 1.5 : 2.5,
                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                    background: 'linear-gradient(135deg, rgba(255,152,0,0.06) 0%, rgba(255,255,255,0) 100%)',
                }}
            >
                <Typography
                    variant={isMobile ? "subtitle1" : "h6"}
                    sx={{
                        fontWeight: 800,
                        color: '#2d2d2d',
                        letterSpacing: '-0.3px',
                    }}
                >
                    {title}
                </Typography>
            </Box>
            <CardContent sx={{ p: isMobile ? '8px !important' : '16px !important', flexGrow: 1 }}>
                <Box
                    sx={{
                        height: responsiveHeight,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        overflow: 'hidden',
                    }}
                >
                    {isLoading ? (
                        <CircularProgress
                            sx={{
                                color: '#ff9800',
                            }}
                            thickness={4}
                        />
                    ) : (
                        <BarChart
                            labels={chartData.labels}
                            datasets={chartData.datasets}
                            showValues={showValues}
                        />
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};

export default CardGraph;
